import { useLocation } from 'react-router-dom';

const isItemActive = (currentPathname, itemPath, matchPaths) => {
  const pathsToCheck = [];

  if (itemPath) {
    const basePath = itemPath.split('?')[0];
    pathsToCheck.push(basePath);
  }

  if (matchPaths && matchPaths.length > 0) {
    pathsToCheck.push(...matchPaths.map((p) => p.split('?')[0]));
  }

  return pathsToCheck.some(
    (p) => currentPathname === p || currentPathname.startsWith(p + '/')
  );
};

const SidebarItem = ({ item, disableActive = false }) => {
  const { pathname } = useLocation();
  const active = disableActive
    ? false
    : isItemActive(pathname, item.path, item.matchPaths);

  const className = `sidebar-item sidebar-link${active ? ' active' : ''}`;

  const content = (
    <>
      {item.icon && <span className={item.icon} />}
      <span>{item.label}</span>
    </>
  );

  if (item.externalUrl) {
    return (
      <li className={className} id={item.id}>
        <a href={item.externalUrl} target="_blank" rel="noopener noreferrer">
          {content}
        </a>
      </li>
    );
  }

  return (
    <li className={className} id={item.id}>
      <a href={item.path}>{content}</a>
    </li>
  );
};

export default SidebarItem;
export { isItemActive };
